import { AdobeMethods } from '../../../../services/adobe-launch/adobe-launch.methods';
import { AdobePageName } from '../../../../services/adobe-launch/adobe-launch.pages';
import { AdobeAnalyticsProcessStep } from '../../../../services/adobe-launch/adobe-launch.process';
import { CtaNames } from '../../../../services/adobe-launch/adobe-launch.cta';

export const configData = {
    adobeInfoOnlyPageLoad: [
        {
            method: AdobeMethods.PAGE_LOAD,
            data: [AdobePageName.GRANTEE_NVG_WELCOME_PAGE_INFO_ONLY],
        },
    ],
    adobeLimitedOnlyPageLoad: [
        {
            method: AdobeMethods.PAGE_LOAD,
            data: [AdobePageName.GRANTEE_NVG_WELCOME_PAGE_LIMITED],
        },
    ],

    onGetStartedClickedInfoOnly: [
        {
            method: AdobeMethods.TRACK_ACTION,
            data: [
                {
                    location: AdobeAnalyticsProcessStep.NON_VG_CLIENT_WELCOME_INFO_ONLY,
                    ctaName: CtaNames.GET_STARTED,
                    ctaType: 'button',
                },
            ],
        },
    ],
    onGetStartedClickedLimited: [
        {
            method: AdobeMethods.TRACK_ACTION,
            data: [
                {
                    location: AdobeAnalyticsProcessStep.NON_VG_CLIENT_WELCOME_LIMITED,
                    ctaName: CtaNames.GET_STARTED,
                    ctaType: 'button',
                },
            ],
        },
    ],
};
